import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <div className="relative h-[60vh] md:h-screen mt-16 md:mt-24">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/a4.webp)',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        </div>
      </div>

      {/* Pre-Arrival Resources Section */}
      <section id="pre-arrival" className="py-12 md:py-20 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4 uppercase tracking-widest italic" style={{ color: '#F5A623' }}>
            Pre-Arrival Resources
          </h2>
          <p className="text-center text-gray-800 mb-8 md:mb-16 text-sm md:text-base px-4">
            Please use these key sources of information prior to your arrival at Throttle Edge
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {/* Step 1 */}
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 md:p-10 text-center text-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 uppercase tracking-wider">Know Our Rules</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Review all park rules and regulations before your visit to ensure a safe and enjoyable experience.
              </p>
              <Link to="/park-rules">
                <button className="bg-orange-500 text-white px-8 py-3 rounded-lg hover:bg-orange-600 transition-colors uppercase text-sm font-bold tracking-wider">
                  View Rules
                </button>
              </Link>
            </div>

            {/* Step 2 */}
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 md:p-10 text-center text-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 uppercase tracking-wider">Sign Waiver Forms</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Complete waiver forms once annually before your first visit. Required for all participants.
              </p>
              <p className="text-orange-500 font-bold text-lg">2026 Waivers Coming Soon!</p>
            </div>

            {/* Step 3 */}
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 md:p-10 text-center text-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:transform hover:scale-105">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4 uppercase tracking-wider">Follow For Updates</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Stay connected with us on social media for the latest news, events, and track conditions.
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <a 
                  href="https://www.facebook.com/ThrottleEdgeMX/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                  title="Facebook"
                >
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/ThrottleEdgeMX/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                  title="Instagram"
                >
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a 
                  href="https://twitter.com/ThrottleEdgeMX" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                  title="Twitter"
                >
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.youtube.com/channel/UCVbLmSeAd-U_98uFN3bHPyw" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                  title="YouTube"
                >
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hours and Events Section */}
      <section id="hours-events" className="py-12 md:py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 md:mb-8 uppercase tracking-widest italic">
            Hours and Events
          </h2>
          
          <div className="bg-white border-2 border-black p-4 mb-6 text-center">
            <p className="font-bold text-sm uppercase">
              PLEASE NOTE: ALL GUESTS MUST CHECK IN AT PRO SHOP BEFORE ENTERING THE PARK
            </p>
          </div>

          <div className="text-center mb-8">
            <p className="text-sm">
              Click <a href="#" className="text-red-600 underline font-semibold">here</a> to see what's happening at the Dunes each week regarding hours and track/trail updates!
            </p>
          </div>

          <div className="text-center mb-12">
            <p className="font-bold text-sm uppercase">
              ALL TRACKS & TRAILS ARE CLOSED FOR THE 2025 SEASON!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* Riding Hours */}
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Riding Hours
              </h3>
              <h4 className="font-bold mb-6 text-sm">Winter Hours</h4>
              <div className="space-y-3 text-sm">
                <div>
                  <span className="font-semibold">Monday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Tuesday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Wednesday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Thursday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Friday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Saturday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Sunday</span> - CLOSED
                </div>
              </div>
              <p className="text-xs mt-6 font-bold uppercase">
                ALL TRACKS & TRAILS ARE CLOSED FOR THE 2025 SEASON!
              </p>
              <p className="text-xs mt-4 leading-relaxed">
                PLEASE FOLLOW US ON SOCIAL OR SUBSCRIBE TO OUR EMAIL LIST TO GET THE LATEST UPDATES ON TRACK OR TRAIL USE DURING EVENT DAYS!
              </p>
            </div>

            {/* Event Schedule */}
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Event Schedule
              </h3>
              <p className="font-bold text-sm mt-20">2026 Event Schedule Coming Soon!</p>
            </div>

            {/* Store Hours */}
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-6 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Store Hours
              </h3>
              <h4 className="font-bold mb-6 text-sm">Winter Hours</h4>
              <div className="space-y-3 text-sm">
                <div>
                  <span className="font-semibold">Monday</span> - CLOSED
                </div>
                <div>
                  <span className="font-semibold">Tuesday</span> - 9am to 5:30pm
                </div>
                <div>
                  <span className="font-semibold">Wednesday</span> - 9am to 5:30pm
                </div>
                <div>
                  <span className="font-semibold">Thursday</span> - 9am to 5:30pm
                </div>
                <div>
                  <span className="font-semibold">Friday</span> - 9am to 5:30pm
                </div>
                <div>
                  <span className="font-semibold">Saturday</span> - 9am to 5:30pm
                </div>
                <div>
                  <span className="font-semibold">Sunday</span> - CLOSED
                </div>
              </div>
              <p className="text-xs mt-6 leading-relaxed">
                OPEN on Mondays of holiday weekends
              </p>
              <p className="text-xs leading-relaxed">
                CLOSED on Tuesdays of holiday weekends
              </p>
              <p className="text-xs mt-4 leading-relaxed">
                PLEASE FOLLOW US ON SOCIAL OR SUBSCRIBE TO OUR EMAIL LIST TO GET THE LATEST UPDATES ON TRACK OR TRAIL USE DURING EVENT DAYS!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Rates and Fees Section */}
      <section id="rates-fees" className="py-12 md:py-16 bg-gray-50">
        <div className="max-w-[1200px] mx-auto px-4">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-8 md:mb-16 uppercase tracking-widest italic">
            Rates and Fees
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
            {/* Daily Fees */}
            <div>
              <div className="border-t-2 border-gray-800 mb-6"></div>
              <h3 className="text-2xl font-bold mb-8 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Daily Fees
              </h3>
              <div className="space-y-4 text-sm">
                <div className="text-center">
                  Daily guest admission - PKR 621 per person (under 2 is free)
                </div>
                <div className="text-center">
                  Bikes and ATV riding admission - PKR 7,245 per day, per rider
                </div>
                <div className="text-center">
                  Side by Side admission - PKR 9,315 per day, per driver
                </div>
                <div className="text-center">
                  Passenger admission - PKR 4,140 per day, per passenger
                </div>
                <div className="text-center">
                  Orion/Stacyc - PKR 2,484 per day, per rider
                </div>
                <div className="text-center">
                  Golf cart - PKR 5,175 per day, per driver
                </div>
              </div>
            </div>

            {/* Annual Membership Fees */}
            <div>
              <div className="border-t-2 border-gray-800 mb-6"></div>
              <h3 className="text-2xl font-bold mb-8 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Annual Membership Fees
              </h3>
              <div className="space-y-4 text-sm">
                <div className="text-center">
                  1 rider - PKR 119,025 + HST
                </div>
                <div className="text-center">
                  2 rider family pass - PKR 219,420 + HST
                </div>
                <div className="text-center">
                  3 rider family pass - PKR 316,710 + HST
                </div>
                <div className="text-center">
                  4 rider family pass - PKR 405,720 + HST
                </div>
                <div className="text-center">
                  5 rider family pass - PKR 486,450 + HST
                </div>
                <div className="text-center">
                  6 rider family pass - PKR 558,900 + HST
                </div>
                <div className="text-center">
                  Mini E-Bike membership - PKR 37,260 + HST
                </div>
                <div className="text-center">
                  Golf cart Membership - PKR 41,400 + HST
                </div>
                <div className="text-center">
                  Guest Admission Membership - PKR 8,073 + HST
                </div>
              </div>
            </div>
          </div>

          <div className="my-8 md:my-16"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
            {/* Camping Fees */}
            <div>
              <div className="border-t-2 border-gray-800 mb-6"></div>
              <h3 className="text-2xl font-bold mb-8 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Camping Fees
              </h3>
              <h4 className="font-bold mb-4 text-sm uppercase">Field Camping</h4>
              <div className="space-y-4 text-sm mb-8">
                <div className="text-center">
                  Nightly - PKR 7,245 per vehicle
                </div>
              </div>
              <h4 className="font-bold mb-4 text-sm uppercase">Seasonal Camping</h4>
              <div className="space-y-4 text-sm">
                <div className="text-center italic">
                  Overnight woods camping is for seasonal campers only
                </div>
                <div className="text-center">
                  Seasonal camping pass - PKR 123,165 + HST
                </div>
                <div className="text-center">
                  Serviced camp sites (limited availability) - PKR 826,965 + HST
                </div>
                <div className="text-center">
                  1 extra car per family, per campsite - PKR 41,193 + HST
                </div>
              </div>
            </div>

            {/* Other Fees */}
            <div>
              <div className="border-t-2 border-gray-800 mb-6"></div>
              <h3 className="text-2xl font-bold mb-8 uppercase italic tracking-wider" style={{ color: '#F5A623' }}>
                Other Fees
              </h3>
              <div className="space-y-4 text-sm">
                <div className="text-center">
                  8 x 8 Storage garage rental - PKR 288,765 + HST annually
                </div>
                <div className="text-center">
                  13 x 8 Storage garage rental- PKR 475,065 + HST annually
                </div>
                <div className="text-center">
                  Winter only trailer storage - PKR 41,193 + HST
                </div>
                <div className="text-center">
                  Shop labour rate - PKR 19,663 + HST
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="border-t-2 border-gray-800 mb-16"></div>
          
          {/* Main Track */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a1.jpg" 
                alt="Main Track" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Main Track</h3>
              <p className="text-gray-800 leading-relaxed">
                The main feature of Throttle Edge is our world famous 2km sand track. The course features 
                man-made obstacles with a 40 rider starting gate and underground irrigation system. The track 
                is groomed 4 days per week and irrigated 3 days per week (if applicable)
              </p>
            </div>
          </div>

          {/* Beginner Track */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a2.jpeg" 
                alt="Beginner Track" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">
                Beginner Track - <span className="italic">Presented by Honda</span>
              </h3>
              <p className="text-gray-800 leading-relaxed">
                Our beginner track is designed for those who are just getting started with off-road riding. 
                The course is 1.2 km in length and is also the same course used for our Red Rider training 
                programs for those who have never rode before. Check out our Rider Training section 
                for more information.
              </p>
            </div>
          </div>

          {/* Peewee Track */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a3.jpeg" 
                alt="Peewee Track" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Peewee Track</h3>
              <p className="text-gray-800 leading-relaxed">
                Our peewee track at Throttle Edge is 1.3 kilometres in length with a hybrid underground 
                irrigation system. This track is designed for 50cc and 65cc two-strokes along with up to 
                125cc 4-stroke bikes. This is a great course for kids who want to get the full track riding 
                experience.
              </p>
            </div>
          </div>

          {/* GP Track */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a13.jpg" 
                alt="GP Track" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">GP Track</h3>
              <p className="text-gray-800 leading-relaxed">
                Our GP track is a track designed for all ages to bridge the gap between the beginner track 
                and main track. This novice level track made of clay and top soil is perfect for people who 
                are not ready for the deep sand of the main track.
              </p>
            </div>
          </div>

          {/* Bicycle/Mini e-bike track */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a5.jpeg" 
                alt="Bicycle Track" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Bicycle/Mini e-bike track</h3>
              <p className="text-gray-800 leading-relaxed">
                This track is a track dedicated completely to bicycles, E-bikes, balance bikes and Orions!
              </p>
            </div>
          </div>

          {/* Trails */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a7.jpeg" 
                alt="Trails" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Trails</h3>
              <p className="text-gray-800 leading-relaxed">
                Our trail system offers 3 separate one-directional trails that are close to 10km each in 
                length for bikes, ATV's, and UTV's. The trails are well marked and groomed several times 
                per year offering something fun to ride from beginner to Pro.
              </p>
            </div>
          </div>

          {/* Pro Shop */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a8.jpg" 
                alt="Pro Shop" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Pro Shop</h3>
              <p className="text-gray-800 leading-relaxed">
                Our store offers many great lines of products and accessories and is also open year round. 
                If you are looking for service on your powersports products, be sure to call us for a quote 
                from our service department!
              </p>
            </div>
          </div>

          {/* Camping */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a9.webp" 
                alt="Camping" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Camping</h3>
              <p className="text-gray-800 leading-relaxed">
                Our camping area is a popular place to be in the summer. For overnight camping, we offer 
                camping in our field. For seasonal campers, we have a separate campground located at the 
                edge of the forest which is a very central area of the property. The park also features 2 
                off-grid cabins (couples cabin and family cabin) for guests wanting stay the night!
              </p>
            </div>
          </div>

          {/* Storage Garage */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start mb-12 md:mb-20">
            <div>
              <img 
                src="/a11.jpeg" 
                alt="Storage Garage" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Storage Garage</h3>
              <p className="text-gray-800 leading-relaxed">
                Storage Garage rentals available on a yearly basis for all of your motocross needs. Our two 
                different sized units are perfect to store your bike, parts/accessories, gear and more.
              </p>
            </div>
          </div>

          {/* Other Amenities */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-4 md:gap-8 items-start">
            <div>
              <img 
                src="/a12.jpeg" 
                alt="Other Amenities" 
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 uppercase italic tracking-wider">Other Amenities</h3>
              <p className="text-gray-800 leading-relaxed">
                Throttle Edge offers several other amenities for Throttle Edge guests and members such as our 
                beach and swimming area, beach volleyball court, fishing, cabins, pressure washer services, 
                firewood and ice available, and a full gym for our members!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Park Map Section */}
      <section id="park-map" className="py-0 mb-10 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-0">
          {/* Desktop View - Map with Overlay */}
          <div className="hidden md:block relative">
            {/* Map Image */}
            <img 
              src="/a14.png" 
              alt="Park Map" 
              className="w-full h-auto"
            />
            
            {/* Legend Overlay - Desktop Only */}
            <div className="absolute top-0 right-0 bottom-0 bg-red-600 text-white px-6 py-8 w-72 flex flex-col justify-start shadow-lg">
              <div className="mb-6 pb-4">
                <p className="text-sm font-bold mb-2 uppercase tracking-wide leading-tight">Welcome to Throttle Edge.</p>
                <p className="text-xs leading-tight">Please ask our staff if you have any questions!</p>
              </div>
              
              <div className="space-y-2 text-sm font-bold">
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">1 -</span>
                  <span className="uppercase tracking-wide">Park Entrance</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">2 -</span>
                  <span className="uppercase tracking-wide">Pro Shop</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">3 -</span>
                  <span className="uppercase tracking-wide">Rental Garages</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">4 -</span>
                  <span className="uppercase tracking-wide">Parking Lot 1</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">5 -</span>
                  <span className="uppercase tracking-wide">Parking Lot 2</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">6 -</span>
                  <span className="uppercase tracking-wide">Cabins</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">7 -</span>
                  <span className="uppercase tracking-wide">Seasonal Camping</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">8 -</span>
                  <span className="uppercase tracking-wide">Beginner Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">9 -</span>
                  <span className="uppercase tracking-wide">Peewee Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">10 -</span>
                  <span className="uppercase tracking-wide">Main Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">11 -</span>
                  <span className="uppercase tracking-wide">GP/Novice Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">12 -</span>
                  <span className="uppercase tracking-wide">Bicycle/E Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">13 -</span>
                  <span className="uppercase tracking-wide">Trail 1</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">14 -</span>
                  <span className="uppercase tracking-wide">Trail 2</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">15 -</span>
                  <span className="uppercase tracking-wide">Trail 3</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">16 -</span>
                  <span className="uppercase tracking-wide">Rider Training</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">17 -</span>
                  <span className="uppercase tracking-wide">Beach</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">18 -</span>
                  <span className="uppercase tracking-wide">Pavilion</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">19 -</span>
                  <span className="uppercase tracking-wide">Volleyball</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">20 -</span>
                  <span className="uppercase tracking-wide">Playground</span>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile View - Map and Legend Stacked */}
          <div className="md:hidden">
            {/* Map Image */}
            <img 
              src="/a14.png" 
              alt="Park Map" 
              className="w-full h-auto"
            />
            
            {/* Legend Below Map - Mobile Only */}
            <div className="bg-red-600 text-white px-4 py-6">
              <div className="mb-4 pb-3 border-b border-white">
                <p className="text-sm font-bold mb-2 uppercase tracking-wide leading-tight">Welcome to Throttle Edge.</p>
                <p className="text-xs leading-tight">Please ask our staff if you have any questions!</p>
              </div>
              
              <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs font-bold">
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">1 -</span>
                  <span className="uppercase tracking-wide">Park Entrance</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">2 -</span>
                  <span className="uppercase tracking-wide">Pro Shop</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">3 -</span>
                  <span className="uppercase tracking-wide">Rental Garages</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">4 -</span>
                  <span className="uppercase tracking-wide">Parking Lot 1</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">5 -</span>
                  <span className="uppercase tracking-wide">Parking Lot 2</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">6 -</span>
                  <span className="uppercase tracking-wide">Cabins</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">7 -</span>
                  <span className="uppercase tracking-wide">Seasonal Camping</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">8 -</span>
                  <span className="uppercase tracking-wide">Beginner Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">9 -</span>
                  <span className="uppercase tracking-wide">Peewee Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">10 -</span>
                  <span className="uppercase tracking-wide">Main Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">11 -</span>
                  <span className="uppercase tracking-wide">GP/Novice Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">12 -</span>
                  <span className="uppercase tracking-wide">Bicycle/E Track</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">13 -</span>
                  <span className="uppercase tracking-wide">Trail 1</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">14 -</span>
                  <span className="uppercase tracking-wide">Trail 2</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">15 -</span>
                  <span className="uppercase tracking-wide">Trail 3</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">16 -</span>
                  <span className="uppercase tracking-wide">Rider Training</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">17 -</span>
                  <span className="uppercase tracking-wide">Beach</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">18 -</span>
                  <span className="uppercase tracking-wide">Pavilion</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">19 -</span>
                  <span className="uppercase tracking-wide">Volleyball</span>
                </div>
                <div className="flex">
                  <span className="mr-2 flex-shrink-0">20 -</span>
                  <span className="uppercase tracking-wide">Playground</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default App;
